export const SOCIAL_PLATFORM = {
  WHATSAPP: 'whatsapp',
  FACEBOOK: 'facebook',
  LINE: 'line',
  TEL: 'tel',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  TIKTOK: 'tiktok',
} as const

export const SOCIAL_LABEL = {
  WHATSAPP: 'WhatsApp',
  FACEBOOK: 'Facebook',
  LINE: 'Line',
  TEL: 'Tel',
  INSTAGRAM: 'Instagram',
  YOUTUBE: 'YouTube',
  TIKTOK: 'TikTok',
} as const

export const SOCIAL_COLORS = {
  WHATSAPP: 'whatsapp',
  FACEBOOK: 'facebook',
  LINE: 'line',
  TEL: 'primary',
} as const

export const SOCIAL_ICONS = {
  WHATSAPP: 'fa-brands fa-whatsapp',
  FACEBOOK: 'fa-brands fa-square-facebook',
  LINE: 'fa-brands fa-line',
  TEL: 'call',
  INSTAGRAM: 'fa-brands fa-square-instagram',
  YOUTUBE: 'fa-brands fa-youtube',
  TIKTOK: 'fa-brands fa-tiktok',
} as const

export const SOCIAL_ICONS_INDUSTRIAL_SERVICE = {
  FACEBOOK: 'fa-brands fa-square-facebook',
  INSTAGRAM: 'fa-brands fa-square-instagram',
  WHATSAPP: 'fa-brands fa-square-whatsapp',
}

export const SOCIAL_ICONS_WEBSPHERE = {
  WHATSAPP: 'fa-brands fa-square-whatsapp',
  FACEBOOK: 'fa-brands fa-square-facebook',
  LINE: 'fa-brands fa-line',
  TEL: 'call',
  INSTAGRAM: 'fa-brands fa-square-instagram',
  YOUTUBE: 'fa-brands fa-square-youtube',
  TIKTOK: 'fa-brands fa-square-tiktok',
} as const

export const ANALYTICS_EVENTS = {
  CLICK_CTA_WHATSAPP: 'click_cta_whatsapp',
  CLICK_CTA_FACEBOOK: 'click_cta_facebook',
  CLICK_CTA_LINE: 'click_cta_line',
  CLICK_CTA_TEL: 'click_cta_tel',
} as const

export const ANALYTICS_CATEGORY = {
  CONTACT: 'Contact',
} as const
